import React from "react";
import "./Products.css"; // Import CSS file
import product1 from "../../assets/icons/product-1.png";
import product2 from "../../assets/icons/product-2.png";
import product3 from "../../assets/icons/product-3.png";
import product4 from "../../assets/used-icons/diploma.png";
import { useTranslation } from "react-i18next";

const Products = () => {
  const { t } = useTranslation();
  const products = [
    { id: 1, title: t('routes.learning-solutions'), icon: product2, route: "/services/learning-solutions" },
    { id: 3, title: t('routes.cmi'), icon: product1, route: 'https://ivorytraining.com/product/cmi' },
    { id: 2, title: t('routes.leadership-solutions'), icon: product3, route: 'https://ivorytraining.com/product/leadership-solutions' },
    { id: 2, title: t('routes.diploma'), icon: product4, route: 'https://ivorytraining.com/diploma/index.html' },
  ];

  return (
    <section className="infographic-container">
      <h2 className="section-title"> {t('home.ivory-products')}</h2>
      <div className="products-grid">
        {products.map((product, i) => (
          <a href={product.route} key={i} className="product-card">
            <img src={product.icon} alt="product-icon" />
            <p className="product-title">{product.title}</p>
          </a>
        ))}
      </div>
    </section>
  );
};

export default Products;